import '@Pages/GeoMMM/Results/Components/BestAndWorstLegend.scss';
import { currencyFormatter } from '@blisspointmedia/bpm-types/dist/MMMUtils';

export const colorsWorst = [
  '#FF2630FF',
  '#FF2630FF',
  '#FF2630CC',
  '#FF2630B3',
  '#FF263099',
  '#FF263080',
  '#FF263066',
  '#FF26304D',
  '#FF263033',
  '#FF26301A'
];

export const colorsBest = [
  '#0194FFFF',
  '#0194FFE6',
  '#0194FFCC',
  '#0194FFB3',
  '#0194FF99',
  '#0194FF80',
  '#0194FF66',
  '#0194FF4D',
  '#0194FF33',
  '#0194FF1A'
];

type GeoRankMap = Record<
  string,
  {
    rank: number;
    dma: string;
    incrementalOutcome: number;
    spend: number;
    response: number;
  }
>;

interface BestAndWorstLegendProps {
  label: string;
  data: GeoRankMap;
  dataFormatter: (value: number) => string;
  geoNames: Record<string, string>;
  isBest: boolean;
}

export const BestAndWorstLegend = ({
  label,
  data,
  dataFormatter,
  isBest,
  geoNames
}: BestAndWorstLegendProps) => {
  const colors = isBest ? colorsBest : colorsWorst;

  const items = Object.values(data);

  items.sort((a, b) => a.rank - b.rank);

  return (
    <div className='response-table'>
      <div className='response-header'>
        <div className='section-label'>{isBest ? `Best ${label}` : `Worst ${label}`}</div>
        <div className='section-response'>{label}</div>
        <div className='section-spend'>Spend</div>
      </div>

      {items.map((item, i) => {
        const bg = colors[i];
        return (
          <div className='response-row' key={item.dma}>
            <div className='col-city'>
              <span className='rank-icon' style={{ backgroundColor: bg }} />
              <span className='rank-number'>{`${i + 1}. `}</span>
              <span className='geo-name'>{geoNames[item.dma]}</span>
            </div>
            <div className='col-response'>{dataFormatter(item.response)}</div>
            <div className='col-spend'>{currencyFormatter.format(item.spend, 0)}</div>
          </div>
        );
      })}
    </div>
  );
};
